import { render, staticRenderFns } from "./AddResourceDrawer.vue?vue&type=template&id=1b16b246&scoped=true&"
import script from "./AddResourceDrawer.vue?vue&type=script&lang=js&"
export * from "./AddResourceDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AddResourceDrawer.vue?vue&type=style&index=0&id=1b16b246&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b16b246",
  null
  
)

export default component.exports